import React from "react";
import { EmptyState } from "@/components/States";

function fmtDate(iso) {
  if (!iso) return "";
  const [y, m, d] = iso.split("-");
  return `${d}/${m}/${y}`;
}

export function CommonNumberCard({ date, rows = [], testId = "common-number-card" }) {
  const displayRows = (rows || []).slice(0, 2);
  if (displayRows.length === 0) {
    return <EmptyState title="No numbers published" subtitle="Common numbers have not been added yet." testId={`${testId}-empty`} />;
  }

  return (
    <div className="w-full max-w-2xl mx-auto" data-testid={testId}>
      {/* ONE single continuous board, 16:9 */}
      <div className="rounded-3xl overflow-hidden border border-slate-200 shadow-[0_12px_40px_-12px_rgba(0,0,0,0.25)] aspect-video flex flex-col bg-white">
        {/* Dark navy/black date header (edge to edge, top rounded) */}
        <div className="bg-slate-900 text-white text-center flex items-center justify-center flex-shrink-0 py-3 sm:py-4">
          <span className="font-heading font-black text-xl sm:text-3xl tracking-wide" data-testid="common-card-date">
            Date: {fmtDate(date)}
          </span>
        </div>

        {/* Entries stacked with no gaps — one board */}
        <div className="flex-1 flex flex-col min-h-0">
          {displayRows.map((r, i) => (
            <React.Fragment key={r.id || i}>
              {/* Orange header row */}
              <div className="grid grid-cols-3 flex-1 min-h-0 bg-orange-500 text-white border-t border-slate-200" data-testid={`common-card-header-${i}`}>
                {["Direct", "House", "Ending"].map((h, hi) => (
                  <div key={h} className={`flex items-center justify-center font-heading font-bold text-base sm:text-2xl ${hi > 0 ? "border-l border-white/30" : ""}`}>
                    {h}
                  </div>
                ))}
              </div>
              {/* White value row */}
              <div className="grid grid-cols-3 flex-1 min-h-0 bg-white text-slate-900" data-testid={`common-card-values-${i}`}>
                {[r.direct, r.house, r.ending].map((v, vi) => (
                  <div key={vi} className={`flex items-center justify-center font-heading font-black text-xl sm:text-4xl tabular-nums ${vi > 0 ? "border-l border-slate-200" : ""}`}>
                    {v || "-"}
                  </div>
                ))}
              </div>
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}
